<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div>
    <v-select
      :disabled="loading"
      v-model="value"
      :items="list_devices"
      item-text="serialNumber"
      item-value="accountId"
      single-line
      multiple
      chips
      :placeholder="language.t('FormFields.DeviceSelect.chooseDevice')"
      v-bind="$attrs"
      v-on="listners"
    >
      <v-divider
        slot="prepend-item"
        class="mt-2"
      />
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0 && value.length == list_devices.length">
          <span> {{ language.t('FormFields.DeviceSelect.allDevices') }}</span>
        </v-chip>
        <v-chip v-if="index === 0 && value.length != list_devices.length && value.length > 1">
          <span>{{ value.length }} {{ language.t('FormFields.DeviceSelect.multipleDevices') }}</span>
        </v-chip>
        <v-chip v-if="index === 0 && value.length != list_devices.length && value.length === 1">
          <span>{{ value.length }} {{ language.t('FormFields.DeviceSelect.oneDevice') }}</span>
        </v-chip>
      </template>
      <template
        slot="item"
        slot-scope="data"
      >
        {{ data.item.accountId }} {{ data.item.serialNumber }} - {{ data.item.designator }}
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    list_devices: [],
    value: []
  }),
  props: {
    devices: Array,
    defaultAll: { type: Boolean, required: false, default: true }
  },
  watch: {
    devices(val) {
      this.list_devices = val;
      if (this.defaultAll) {
        this.value = this.list_devices.map(a => a.accountId);
        this.$emit('input', this.value);
      }
      this.loading = false;
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.value.length == this.list_devices.length) {
          this.value = [];
        } else {
          this.value = this.list_devices.map(a => a.accountId);
        }
        this.$emit('input', this.value);
      });
    }
  },
  computed: {
    listners() {
      return {
        ...this.$listners,
        input: event =>
          this.$emit('input', event)
      }
    }
  }
};
</script>
